export enum ContractType {
	MAIN = 'MAIN',
	ADDITIVE = 'ADDITIVE',
	TERMINATION = 'TERMINATION'
}